import { render, staticRenderFns } from "./smarttablequestion.vue?vue&type=template&id=d72cc2b2&scoped=true"
import script from "./smarttablequestion.vue?vue&type=script&lang=js"
export * from "./smarttablequestion.vue?vue&type=script&lang=js"
import style0 from "./smarttablequestion.vue?vue&type=style&index=0&id=d72cc2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72cc2b2",
  null
  
)

export default component.exports